import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import LabResultConfigEditDialog from '../../Dialogs/Configuration/LabResultConfigEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function LabResultsConfigTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getLabResultsConfig = async function () {
            let url = `api/v1/labresultconfig/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getLabResultsConfig();
    }, [fetchDataAuthenticated, includeDeleted, refresh]);

    const tableColumns = [
        {
            Header: 'SampleName',
            accessor: (originalRow, rowIndex) => {
                return (originalRow.sampleName === "") ? (originalRow.component) : (originalRow.sampleName);
            },
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'Quality',
            accessor: 'qualityName',
            filter: 'includesString'
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'includesString'
        },
        {
            Header: 'SamplingPoint',
            accessor: 'samplingPoint',
            filter: 'includesString'
        },
        {
            Header: 'UnitArea',
            accessor: 'unitArea',
            filter: 'includesString'
        },
        {
            Header: 'Analysis',
            accessor: 'analysis',
            filter: 'includesString'
        },
        {
            Header: 'Component',
            accessor: 'component',
            filter: 'includesString'
        },
        {
            Header: 'LabResultType',
            accessor: 'labResultType',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={{}} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function LabResultsConfigConfiguration() {

    const { businessUnits } = useBusinessUnits(false);
    
    const getNewLabResultConfig = () => {
        return { labResultConfigId: null, qualityId: null, businessUnitId: null, isDeleted: false }
    };



    return (
        <CommonConfigPage
            title="Lab Results Config"
            Table={LabResultsConfigTable}
            Dialog={LabResultConfigEditDialog}
            getNewConfigObject={getNewLabResultConfig}
            businessUnits={businessUnits}
        />
    );
}

export default LabResultsConfigConfiguration;